import Card from "react-bootstrap/Card";
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Image } from "@chakra-ui/image";

function LocationPin({ mapData, setBackdrop }) {
  const [showModal, setShowModal] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);

  window.addEventListener("resize", () => {
    setWidth(window.innerWidth);
  });

  const closeModal = () => {
    setShowModal(false);
    setBackdrop(true);
  };
  const openModal = () => {
    setBackdrop(false);
    setShowModal(true);
  };

  return (
    <>
      <Card
        style={{
          width: "5rem",
          top: "10%",
          left: "50%",
          transform: "translate(-50%, -100%)",
        }}
        onClick={() => {
          openModal();
        }}
      >
        <Card.Body className='p-1'>
          <Card.Img variant='top' src={mapData.photo} />
        </Card.Body>
      </Card>

      <span className='beacon'>
        <div className='pin'></div>
        <span className='pin-text'>{mapData.store_name}</span>
      </span>

      <Modal show={showModal} onHide={closeModal} size='lg' centered>
        <Modal.Header closeButton>
          <Modal.Title>{mapData.store_name}</Modal.Title>
        </Modal.Header>
        <Image
          src={mapData.photo}
          fallbackSrc='../../logo.png'
          alt='A Placeholder Image'
          style={{ maxHeight: width > 768 ? "768px" : width }}
          className='img-fluid mx-auto'
        />
      </Modal>
    </>
  );
}

export default LocationPin;
